import { GzGeneralUpdateWebComponent } from './component/GzGeneralUpdateWebComponent';

export { GzGeneralUpdateWebComponent };
